module.exports = __webpack_public_path__ + "nc_static/media/star-sidebar.f3e2ec72.svg";